import { faker } from "@faker-js/faker";
import type { Meta, StoryObj } from "@storybook/react";

import { fakeBaseUserAvatarProps } from "@/__mocks__/mockBaseTypes";
import type { ChannelPreviewCardProps } from "@/ui/components/messages/cards/ChannelPreviewCard";
import ChannelPreviewCard from "@/ui/components/messages/cards/ChannelPreviewCard";

const mockMembers = faker.helpers.multiple(() => fakeBaseUserAvatarProps(), {
  count: { max: 4, min: 2 },
});

const StoryMeta: Meta<ChannelPreviewCardProps> = {
  title: "Components/Messages/Channel Preview Card",
  component: ChannelPreviewCard,
  argTypes: {
    channelName: { control: "text" },
    isGroupChannel: { control: "boolean" },
    isLastMessageFileMessage: { control: "boolean" },
    lastMessage: { control: "text" },
    lastMessageTime: { control: "text" },
    onSelect: { action: "channel selected" },
    providerMembersDescription: { control: "text" },
    unreadMessageCount: { control: "number" },
  },
  args: {
    channelName: "Therapist",
    channelUrl: "PT_THERAPIST",
    isGroupChannel: false,
    isLastMessageFileMessage: false,
    lastMessage: "Thanks for the session, see you next week!",
    lastMessageTime: "Yesterday",
    members: [mockMembers[0]],
    providerMembersDescription: "Jean Grey, Scott Summers",
    unreadMessageCount: 0,
  },
};

type Story = StoryObj<ChannelPreviewCardProps>;

const Primary: Story = {};

const Unread: Story = {
  args: {
    unreadMessageCount: 3,
  },
};

const FileMessage: Story = {
  args: {
    isLastMessageFileMessage: true,
  },
};

const EmptyChannel: Story = {
  args: {
    lastMessage: undefined,
    lastMessageTime: undefined,
  },
};

const GroupChannel: Story = {
  args: {
    channelName: "Care Team",
    isGroupChannel: true,
    members: mockMembers,
  },
};

export { EmptyChannel, FileMessage, GroupChannel, Primary, Unread };
export default StoryMeta;
